<template>
  <div class="question text_left">
    <title-bar-back :title="'客户服务'" @back="back">
      <div class="title_right"></div>
    </title-bar-back>
    <div class="call_service font12 font_weight400 line_height_17 text_center">
      <div class="ser_item border_r">
        <img src="@/assets/mine/inform/icon_service@2x.png" alt="" />
        <div>在线客服</div>
        <div class="item_call">（08:30-21:00）</div>
      </div>
      <div class="ser_item">
        <img src="@/assets/mine/inform/icon_call@2x.png" alt="" />
        <div>客服热线</div>
        <div class="item_call"><a href="tel:0571-86685812">0571-86685812</a></div>
      </div>
    </div>
    <div class="que_t">猜你想要了解</div>
    <div
      v-for="(item, index) in infoList"
      :key="index"
      class="que_list clearfix"
    >
      <div class="left">
        <img :src="item.pic" alt="" class="list_img" />
        <div class="list_title">{{ item.title }}</div>
      </div>
      <div class="list_right left">
        <div
          v-for="(sub, index1) in item.subs"
          :key="index1"
          class="list_sub"
          @click="goInfoDet(sub)"
        >
          {{ sub.title }}
          <img
            src="@/assets/common/icon_back_b87_24@2x.png"
            alt=""
            class="go_img right"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const TitleBarBack = () =>
  import("@/components/TitleBarBack").then(m => m.default || m);
export default {
  name: "QuestionList",
  components: {
    TitleBarBack
  },
  data() {
    return {
      infoList: [
        {
          title: "海外保障",
          pic: require("@/assets/mine/1@2x.png"),
          subs: [
            {
              title: "海外直供",
              url: "/mine/question/detail?key=1&name=海外直供"
            },
            {
              title: "正品保障",
              url: "/mine/question/detail?key=2&name=正品保障"
            }
          ]
        },
        {
          title: "新手指南",
          pic: require("@/assets/mine/2@2x.png"),
          subs: [
            {
              title: "购买流程",
              url: "/mine/question/detail?key=3&name=购买流程"
            },
            {
              title: "常见问题",
              url: "/mine/question/detail?key=4&name=常见问题"
            }
          ]
        },
        {
          title: "售后服务",
          pic: require("@/assets/mine/3@2x.png"),
          subs: [
            {
              title: "破损包赔",
              url: "/mine/question/detail?key=6&name=破损包赔"
            },
            {
              title: "退货须知",
              url: "/mine/question/detail?key=7&name=退货须知"
            },
            {
              title: "退款说明",
              url: "/mine/question/detail?key=8&name=退款说明"
            }
          ]
        },
        {
          title: "物流配送",
          pic: require("@/assets/mine/4@2x.png"),
          subs: [
            {
              title: "配送方式",
              url: "/mine/question/detail?key=10&name=配送方式"
            },
            {
              title: "物流追踪",
              url: "/mine/question/detail?key=11&name=物流追踪"
            }
          ]
        },
        {
          title: "关于我们",
          pic: require("@/assets/mine/5@2x.png"),
          subs: [
            {
              title: "关于平台",
              url: "/mine/question/detail?key=12&name=关于平台"
            },
            {
              title: "告消费者书",
              url: "/mine/question/detail?key=13&name=告消费者书"
            }
          ]
        }
      ]
    };
  },
  methods: {
    back() {
      this.$router.back();
    },
    goInfoDet(sub) {
      this.$router.push(sub.url);
    }
  }
};
</script>

<style scoped>
a:link {
  text-decoration: none;
  color: #bf9264;
}
a:visited {
  text-decoration: none;
  color: #bf9264;
}
a:hover {
  text-decoration: none;
  color: #bf9264;
}
a:active {
  text-decoration: none;
  color: #bf9264;
}
.title_right {
  width: 36px;
}
.call_service {
  display: flex;
  background: #fff;
  box-shadow: 0px 3px 6px -3px rgba(193, 200, 207, 0.5);
}
.ser_item {
  padding: 15px 0;
  flex: 1;
  color: #bf9264;
}
.ser_item img {
  width: 38px;
  height: 38px;
}
.item_call {
  margin-top: 8px;
}
.border_r {
  border-right: 1px solid rgba(0, 0, 0, 0.06);
}
.que_t {
  /* margin-top: 40px; */
  font-size: 12px;
  font-weight: 400;
  color: rgba(153, 153, 153, 1);
  line-height: 37px;
  padding-left: 10px;
}
.que_list {
  margin-bottom: 10px;
  background: #fff;
  /* padding: 0 7px 0 20px; */
}
.list_img {
  display: block;
  width: 24px;
  height: 24px;
  margin: 23px auto 0;
}
.list_title {
  padding-top: 7px;
  font-size: 14px;
  font-weight: 400;
  color: rgba(34, 34, 34, 1);
  line-height: 20px;
  padding: 7px 20px 0;
}
.list_right {
  border-left: 1px solid #eee;
  padding-left: 16px;
  min-width: 65%;
}
.list_sub {
  font-size: 14px;
  font-weight: 400;
  color: rgba(34, 34, 34, 1);
  line-height: 48px;
  border-bottom: 1px solid #eee;
}
.list_sub {
  width: 100%;
}
.go_img {
  width: 18px;
  height: 18px;
  margin-top: 15px;
}
</style>
